import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/root/jwlplanthire/layouts/default.vue").then(m => m.default || m)),
  unknown: defineAsyncComponent(() => import("/root/jwlplanthire/layouts/unknown.vue").then(m => m.default || m))
}